module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Modul Pembelajaran',
          to: {
            path: '/modul-pembelajaran'
          },
          exact: true,
        },
        {
          text: 'Laporan Modul',
          to: {
            path: '/modul-pembelajaran/report'
          },
          exact: true,
        },
        {
          text: 'Detail Laporan'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold font-size-20 mt-3 mb-5"
  }, [_vm._v("\n        Detail Laporan\n    ")]), _vm._v(" "), _c('v-card', {
    staticClass: "mb-10",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "border-bottom py-3"
  }, [_c('div', {
    staticClass: "font-size-16 black--text"
  }, [_vm._v("\n                " + _vm._s(_vm.data.module.subject) + "\n            ")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-5"
  }, [_c('v-row', [_c('v-col', [_c('div', [_c('label', [_vm._v(" Nama Modul ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: (_vm.data.module.name),
      callback: function($$v) {
        _vm.$set(_vm.data.module, "name", $$v)
      },
      expression: "data.module.name"
    }
  })], 1)]), _vm._v(" "), _c('v-col', [_c('div', [_c('label', [_vm._v(" Judul Modul ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: (_vm.data.module.name),
      callback: function($$v) {
        _vm.$set(_vm.data.module, "name", $$v)
      },
      expression: "data.module.name"
    }
  })], 1)])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('div', [_c('label', [_vm._v(" Semester ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: (_vm.data.module.semester),
      callback: function($$v) {
        _vm.$set(_vm.data.module, "semester", $$v)
      },
      expression: "data.module.semester"
    }
  })], 1)]), _vm._v(" "), _c('v-col', [_c('div', [_c('label', [_vm._v(" Bab ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: (_vm.data.module.bab),
      callback: function($$v) {
        _vm.$set(_vm.data.module, "bab", $$v)
      },
      expression: "data.module.bab"
    }
  })], 1)])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('div', [_c('label', [_vm._v(" Subbab ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: (_vm.data.module.subab),
      callback: function($$v) {
        _vm.$set(_vm.data.module, "subab", $$v)
      },
      expression: "data.module.subab"
    }
  })], 1)]), _vm._v(" "), _c('v-col', [_c('div', [_c('label', [_vm._v(" Tanggal Laporan ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: (_vm.data.created_at),
      callback: function($$v) {
        _vm.$set(_vm.data, "created_at", $$v)
      },
      expression: "data.created_at"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v(" Kategori Laporan ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: (_vm.data.report_category),
      callback: function($$v) {
        _vm.$set(_vm.data, "report_category", $$v)
      },
      expression: "data.report_category"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v(" Detail Laporan ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: (_vm.data.report_detail),
      callback: function($$v) {
        _vm.$set(_vm.data, "report_detail", $$v)
      },
      expression: "data.report_detail"
    }
  })], 1), _vm._v(" "), (_vm.data.url_image.length > 0) ? _c('div', [_c('label', [_vm._v(" Hasil Unggahan ")]), _vm._v(" "), _vm._l((_vm.data.url_image), function(item, i) {
    return _c('v-card', {
      key: i,
      staticClass: "mt-1",
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-text', {
      staticClass: "pa-3"
    }, [_c('div', {
      staticClass: "d-flex justify-space-between align-center"
    }, [_c('span', {
      staticClass: "font-weight-bold primary--text"
    }, [_c('v-icon', {
      staticClass: "mr-2",
      staticStyle: {
        "font-size": "18px !important"
      },
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("mdi-image")]), _vm._v(_vm._s(_vm.getShortName(item)))], 1), _vm._v(" "), _c('div', [_c('v-btn', {
      staticClass: "font-weight-bold blew--text mt-0",
      staticStyle: {
        "background-color": "#e1f4fc"
      },
      attrs: {
        "text": "",
        "depressed": "",
        "color": "#e8f5fa"
      },
      on: {
        "click": function($event) {
          return _vm.openImage(item)
        }
      }
    }, [_vm._v("\n                                    Lihat Gambar\n                                ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "font-weight-bold blew--text mt-0",
      staticStyle: {
        "background-color": "#e1f4fc"
      },
      attrs: {
        "text": "",
        "depressed": "",
        "color": "#e8f5fa"
      },
      on: {
        "click": function($event) {
          return _vm.downloadImage(item)
        }
      }
    }, [_c('v-icon', {
      staticStyle: {
        "font-size": "18px !important"
      }
    }, [_vm._v("mdi-download")])], 1)], 1)])])], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('div', [_c('label', [_vm._v(" Status ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.data.status),
      callback: function($$v) {
        _vm.$set(_vm.data, "status", $$v)
      },
      expression: "data.status"
    }
  }, [_c('v-radio', {
    staticClass: "radio-custom",
    attrs: {
      "label": "To Do",
      "value": "TO_DO",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "radio-custom",
    attrs: {
      "label": "In Progress",
      "value": "IN_PROGRESS",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "radio-custom",
    attrs: {
      "label": "Done",
      "value": "DONE",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "py-4 px-5 border-top-1"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "depressed": "",
      "color": "blew"
    },
    on: {
      "click": function($event) {
        return _vm.updateStatus()
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), (_vm.openDialogImage) ? _c('v-dialog', {
    attrs: {
      "max-width": "90vw",
      "max-height": "90vh"
    },
    on: {
      "click:outside": function($event) {
        _vm.openDialogImage = false
      }
    },
    model: {
      value: (_vm.openDialogImage),
      callback: function($$v) {
        _vm.openDialogImage = $$v
      },
      expression: "openDialogImage"
    }
  }, [_c('v-card', {
    staticClass: "d-flex flex-column align-center"
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.imageShow,
      "contain": "",
      "max-width": "100%",
      "max-height": "80vh"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5465f5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/modul_belajar_2022/components/ModulReportDetail.vue
// module id = 1892
// module chunks = 1